import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, House } from 'react-bootstrap-icons';

const Breadcrumb = () => {
  const location = useLocation();
  
  const getBreadcrumbItems = () => {
    const pathnames = location.pathname.split('/').filter(x => x);
    const breadcrumbItems = [
      { name: 'Inicio', path: '/', icon: <House size={14} /> }
    ];

    let currentPath = '';
    pathnames.forEach((pathname, index) => {
      currentPath += `/${pathname}`;
      
      let name = pathname;
      let icon = null;
      
      // Mapear nombres más amigables
      switch (pathname) {
        case 'admin':
          name = 'Administración';
          break;
        case 'roles':
          name = 'Roles';
          break;
        case 'organizations':
          name = 'Organizaciones';
          break;
        case 'persons':
          name = 'Personas';
          break;
        case 'academic-content':
          name = 'Marco Académico';
          break;
        case 'academic-schedule':
          name = 'Horario Académico';
          break;
        case 'docente':
          name = 'Vista Docente';
          break;
        case 'utp':
          name = 'Vista UTP';
          break;
        default:
          name = pathname.charAt(0).toUpperCase() + pathname.slice(1);
      }

      breadcrumbItems.push({
        name,
        path: currentPath,
        icon
      });
    });

    return breadcrumbItems;
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <nav aria-label="breadcrumb" className="artemis-breadcrumb">
      <ol className="breadcrumb mb-0">
        {breadcrumbItems.map((item, index) => (
          <li 
            key={item.path}
            className={`breadcrumb-item ${index === breadcrumbItems.length - 1 ? 'active' : ''}`}
          >
            {index === breadcrumbItems.length - 1 ? (
              <span className="d-flex align-items-center gap-1">
                {item.icon}
                {item.name}
              </span>
            ) : (
              <Link 
                to={item.path} 
                className="d-flex align-items-center gap-1 text-decoration-none"
              >
                {item.icon}
                {item.name}
              </Link>
            )}
            {index < breadcrumbItems.length - 1 && (
              <ChevronRight size={12} className="mx-2 text-muted" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
